<template>
  <div class="pay-success">
    <!-- 引入公共头部 -->
    <dg-header :showBack="true" :title="'支付状态'"></dg-header>
    <div class="pay-success-wrap">
      <span class="pay-success-icon">
        <img src="@/assets/images/pay-success-icon.png" alt>
      </span>
      <div class="pay-success-text">
        <p class="success-text">
          支付成功：
          <span>信用抵扣</span>
        </p>
        <p class="success-text">
          订单金额：
          <span class="success-price">
            <span>JPY</span>{{$route.query.price | setNumber}}
          </span>
        </p>
      </div>
      <router-link class="router-a" replace :to="{path: '/order-detail', query: {id: $route.query.id}}">
        <van-button round type="danger">查看详情</van-button>
      </router-link>
    </div>
  </div>
</template>
<script>
import DgHeader from "@/components/header";
export default {
  data() {
    return {};
  },
  components: {
    DgHeader
  }
};
</script>
<style lang="scss" scoped>
.pay-success {
  padding: 88px 0 0 0;

  .header-wrap {
    background: $bg02;
  }
  .pay-success-wrap {
    width: 100%;
    text-align: center;
    .pay-success-icon {
      width: 100px;
      height: 100px;
      display: inline-block;
      margin-top: 90px;
      > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .pay-success-text{
      margin-top: 50px;
      .success-text{
        font-size: 30px;
        color: $fc03;
        margin-bottom: 10px;
        .success-price{
          color: $fc04;
          >span{
            font-size: 24px;
            margin-right: 6px;
          }
        }
      }
    }
    .router-a{
      display: inline-block;
      margin-top: 50px;
      .van-button{
        width: 300px;
        height: 80px;
        text-align: center;
        line-height: 80px;
        background: $bg05;
        border: none;
        font-size: 30px;
      }
    }
  }
}
</style>
